import type { TypographyProps } from '@components/atoms/typography/types';
import type { DefaultTheme } from 'styled-components';

// Resolves a design-token color name to its palette value.
// `null` means "do not set a color at all", `'inherit'` means "take the parent color".
export const getPaletteColor = (
    color: TypographyProps['color'],
    theme: DefaultTheme,
): string | undefined => {
    switch (color) {
        case null:
            return undefined;
        case 'inherit':
            return 'inherit';
        case 'text-main':
            return theme.palette.textMain;
        case 'text-light':
            return theme.palette.textLight;
        case 'primary-a1':
            return theme.palette.primaryA1;
        case 'primary-a2':
            return theme.palette.primaryA2;
        case 'primary-a3':
            return theme.palette.primaryA3;
        case 'primary-a4':
            return theme.palette.primaryA4;
        case 'primary-a5':
            return theme.palette.primaryA5;
        case 'primary-a6':
            return theme.palette.primaryA6;
        case 'primary-a7':
            return theme.palette.primaryA7;
        case 'secondary-a1':
            return theme.palette.secondaryA1;
        case 'secondary-a2':
            return theme.palette.secondaryA2;
        case 'secondary-a3':
            return theme.palette.secondaryA3;
        case 'secondary-a4':
            return theme.palette.secondaryA4;
        case 'secondary-a5':
            return theme.palette.secondaryA5;
        case 'secondary-a6':
            return theme.palette.secondaryA6;
        case 'secondary-a7':
            return theme.palette.secondaryA7;
        case 'secondary-a8':
            return theme.palette.secondaryA8;
        default:
            return theme.palette.textMain;
    }
};
